import React, { useEffect, useState } from 'react';
import axios from 'axios';
import FilterBar from '../components/FilterBar';
import PageGuide from '../components/PageGuide';
import { BrandDecisionView } from '../components/DecisionIntelligenceViews';
import '../styles/NewDashboard.css';
import filterParams from '../utils/filterParams';

export default function BrandIntelV2({ filters, setLoading }) {
  const [data, setData] = useState({ brands: [], region_sentiment: [] }),
    [busy, setBusy] = useState(true),
    [error, setError] = useState('');
  useEffect(() => {
    const c = new AbortController();
    setBusy(true);
    setLoading(true);
    setError('');
    const params = filterParams(filters);
    // Province sentiment comes from the existing Brand Sentiment route.
    Promise.all([
      axios.get(`/api/decision/brands?${params}`, { signal: c.signal }),
      axios.get(`/api/sentiment/by-region?${filterParams(filters, { entity_group: 'product' })}`, {
        signal: c.signal,
      }),
    ])
      .then(([brands, byRegion]) => setData({ ...brands.data, region_sentiment: byRegion.data?.data || [] }))
      .catch((e) => {
        if (!axios.isCancel(e)) setError('Brand intelligence could not be loaded.');
      })
      .finally(() => {
        setBusy(false);
        setLoading(false);
      });
    return () => c.abort();
  }, [filters, setLoading]);
  return (
    <div className="v2-page">
      <div className="module-header">
        <div className="module-kicker">VOICE OF THE MARKET</div>
        <h2>Brand Intelligence</h2>
        <p>How Syngenta and competing products are discussed, where perception differs, and why.</p>
      </div>
      <FilterBar />
      <PageGuide
        purpose="Compare brand perception across locations and crops, then trace every conclusion back to field conversations."
        steps={[
          'Start with the brand status list.',
          'Use the location matrix to find where sentiment differs.',
          'Read the comments and related products before taking action.',
        ]}
        metrics={[
          {
            name: 'Net sentiment',
            definition: 'Positive share minus negative share among conversations where sentiment was scored.',
          },
          {
            name: 'Needs attention',
            definition: 'Negative or mixed sentiment is sufficiently concentrated to warrant review.',
          },
          {
            name: 'Main crop context',
            definition: 'The crop most often discussed in the same conversations as the selected brand.',
          },
          {
            name: 'Current / emerging / declining',
            definition: 'Whether discussion of the brand is stable, increasing or decreasing over time.',
          },
        ]}
      />
      {error && <div className="decision-empty">{error}</div>}
      <BrandDecisionView data={data} filters={filters} loading={busy} />
    </div>
  );
}
